/**
 * Created by Ning Jiang on 5/24/2019.
 */

import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {BetWayWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {Timeline} from "gsap";
import {PixiesVsPiratesGameConfig} from "../../PixiesVsPiratesGameConfig";

export class PPIndividualWPController extends BetWayWinIndividualWPController {

    constructor(config:IIndividualWinPresentationConfig) {
        super(config);
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        timeline.add([
            () => this.sortSymbolDepthToTop(symbol),
            symbol.changeState({
                state : PixiesVsPiratesGameConfig.instance.SYMBOL_STATES.individualwin,
                setStack : true,
                fadeInDuration : 0.2
            })
        ], startTime);
    }
}